import {
  ActionItemsRequest,
  ActionItemsResponse,
  MenuItemsRequest,
  MenuItemsResponse,
} from "@vrf/fr-vrf-auth-core";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { authorizationRestResource } from "../auth/AuthorizationRestResource";

export const useGetActionItems = () =>
  useRestResourceHook<ActionItemsRequest, ActionItemsResponse>(
    authorizationRestResource.getActionItems,
  );

export const useGetMenuItems = () =>
  useRestResourceHook<MenuItemsRequest, MenuItemsResponse>(
    authorizationRestResource.getMenuItems,
  );
